import React from 'react';
import {
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader
} from '@sendsprint/ui-react/dist/components/Dialog';
import Text from '@sendsprint/ui-react/dist/components/Text';
import Box from '@sendsprint/ui-react/dist/components/Box';
import ButtonLink from '@sendsprint/ui-react/dist/components/ButtonLink';
import { MapImage } from './assets';

interface Props {
  isOpen: boolean;
  handleClose: () => void;
  url: string;
}

const UpdateLocation = ({ isOpen, handleClose, url }: Props) => {
  return (
    <Dialog isOpen={isOpen}>
      <DialogHeader>
        <Box className="ss-flex ss-justify-center ss-mb-5">
          <MapImage className="ss-w-28" />
        </Box>
        <Text variant="h5" className="ss-text-center">
          Update your location
        </Text>
        <Text className="ss-text-center">
          It looks like your profile location is missing or in a region we no longer support. Please
          update your location now to keep using our services seamlessly. If your location is
          unsupported, your account will be deactivated.
        </Text>
      </DialogHeader>

      <DialogBody className="ss-border-t ss-border-[#F9FAFA]">
        <Box className="ss-space-y-7"></Box>
      </DialogBody>
      <DialogFooter className="ss-flex ss-justify-end">
        <ButtonLink
          to={url}
          label="Update location"
          variant="primary"
          isBlock
          onClick={handleClose}
        />
      </DialogFooter>
    </Dialog>
  );
};

export default UpdateLocation;
